import React from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Modal from '..';
import classes from './ModalRedirectToFSC.module.scss';

import { getEnv } from '@config';

const { publicPath } = getEnv();

export default function ({
  title,
  subTitle,
  image,
  handleConfirm,
  textConfirm,
  handleCancel,
  textCancel,
  open,
  imageSource,
  imageStyle,
  extraWidth,
}) {
  const classesFade = [classes.fade];
  if (extraWidth) {
    classesFade.push(classes.extraWidth);
  }
  const imgSrc = image ? `/${image}` : imageSource;
  return (
    <Modal
      className={classes.modal}
      open={open}
      style={{ textAlign: 'center' }}
      fadeClass={classesFade.join(' ')}
      handleClose={handleCancel}
    >
      <Grid item container className={classes.container}>
        {imgSrc && (
          <Grid item xs={12}>
            <img src={`${publicPath}/${imgSrc}`} style={imageStyle} alt="Imagen de precaucion" />
          </Grid>
        )}
        <Grid item xs={12}>
          <h2>{title}</h2>
        </Grid>
        <Grid item xs={12}>
          <h3>{subTitle}</h3>
        </Grid>
      </Grid>
      <Grid item container xs={12} direction="row-reverse">
        <Grid item xs={6} lg={textCancel && handleCancel ? 6 : 12}>
          <Button id="confirm" onClick={handleConfirm} className={[classes.button].join(' ')}>
            {textConfirm}
          </Button>
        </Grid>
        {textCancel && handleCancel && (
          <Grid item xs={6} lg={6}>
            <Button
              id="cancel"
              onClick={handleCancel}
              className={[classes.button, classes.cancelButton, 'button_text'].join(' ')}
            >
              {textCancel}
            </Button>
          </Grid>
        )}
      </Grid>
    </Modal>
  );
}
